import {
  Hydrate,
  QueryClientProvider,
  QueryClient,
} from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { useState } from "react";
import toast from "react-hot-toast";
import { useRouter } from "next/router";

export default function ReactQuery({ children, dehydratedState }) {
  const { locale } = useRouter();
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 60 * 1000,
            onError: (error, query) => {
              let msg =
                locale === "fa"
                  ? `با عرض پوزش، مشکلی پیش آمده است!`
                  : `Something went wrong`;
              if (
                !error?.response?.data?.data &&
                error?.response?.status === 404
              ) {
                toast.error(msg);
                console.log("Error ======== >", error?.response.data);
              } else {
                toast.error(error.toString());
              }
            },
          },
        },
      }),
  );
  return (
    <QueryClientProvider client={queryClient}>
      <Hydrate state={dehydratedState}>
        <ReactQueryDevtools initialIsOpen={false} />
        {children}
      </Hydrate>
    </QueryClientProvider>
  );
}
